const updateUserExtensionValidators = {};

export default updateUserExtensionValidators;
